import { render, staticRenderFns } from "./DetailsFoldout.vue?vue&type=template&id=9c433dca"
import script from "./DetailsFoldout.vue?vue&type=script&lang=ts"
export * from "./DetailsFoldout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports